export default __webpack_public_path__ + "static/media/envelope.bb64910e.svg";